import { localStore } from 'utils/storage'
import type { PromoPopupType } from './config'
import { PROMO_POPUPS_CONFIG } from './config'

export function injectBasillionFont(fontId = 'basillion-font-style') {
  // oxlint-disable-next-line unicorn/prefer-query-selector
  if (document.getElementById(fontId)) {
    return
  }

  const style = document.createElement('style')
  style.id = fontId
  style.innerHTML = `
      @font-face {
        font-family: 'Basillion';
        src: url('https://lfs.creativefabrica.com/fonts/promo-banners/Basillion.woff2') format('woff2');
        font-weight: normal;
        font-style: normal;
        font-display: swap;
      }
    `
  document.head.appendChild(style)
}

export function removeBasillionFont(fontId = 'basillion-font-style') {
  // oxlint-disable-next-line unicorn/prefer-query-selector
  const style = document.getElementById(fontId)
  if (style) {
    document.head.removeChild(style)
  }
}

export const shouldShowPopup = (type: PromoPopupType) => {
  if (typeof window === 'undefined') {
    return false
  }

  const storedDate = localStore.getString(PROMO_POPUPS_CONFIG[type].CLOSE_KEY)
  if (!storedDate) {
    return true
  }

  const storedTimestamp = parseInt(storedDate, 10)
  const now = Date.now()
  const isCadenceExpired = now - storedTimestamp > PROMO_POPUPS_CONFIG[type].CADENCE

  return isCadenceExpired
}

export function getPopupTexts({
  promoPopupType,
  price,
  t,
}: {
  promoPopupType: PromoPopupType
  price?: string
  t: (key: string) => string
}): {
  title: string
  description: string
  buttonText: string
} {
  switch (promoPopupType) {
    case 'LOGGED_OUT':
    case 'LOGGED_IN_UNSUBSCRIBED': {
      return {
        title: t('popups.title_2'),
        description: t('popups.description_2'),
        buttonText: t('popups.download_free'),
      }
    }
    case 'LOGGED_IN_TRIAL': {
      return {
        title: t('popups.title_5'),
        description: t('popups.description_3'),
        buttonText: t('popups.upgrade_now'),
      }
    }
    case 'LOGGED_IN_MONTHLY': {
      return {
        title: t('popups.title_3'),
        description: t('popups.description_3'),
        buttonText: t('popups.upgrade_now'),
      }
    }
    case 'LOGGED_IN_CANCELLED': {
      return {
        title: t('popups.title_4'),
        description: t('popups.description_4'),
        buttonText: t('popups.activate'),
      }
    }
    case 'LOGGED_IN_YEARLY': {
      return {
        title: t('popups.title'),
        description: t('popups.description').replace('#price#', price || ''),
        buttonText: t('popups.extend_now').replace('#price#', price || ''),
      }
    }

    default: {
      return {
        title: '',
        description: '',
        buttonText: '',
      }
    }
  }
}

// oxlint-disable-next-line complexity
export function getImageProps(variant: PromoPopupType, variantNumber: number) {
  let name =
    (variantNumber === 1 && 'blue') ||
    (variantNumber === 2 && 'darkblue') ||
    (variantNumber === 3 && 'purple') ||
    ''
  switch (variant) {
    case 'LOGGED_IN_TRIAL':
    case 'LOGGED_IN_MONTHLY': {
      name =
        (variantNumber === 1 && 'blue_v2') ||
        (variantNumber === 2 && 'darkblue_v2') ||
        (variantNumber === 3 && 'purple_v2') ||
        ''
      break
    }

    case 'LOGGED_OUT':
    case 'LOGGED_IN_UNSUBSCRIBED': {
      name =
        (variantNumber === 1 && 'blue_v3') ||
        (variantNumber === 2 && 'darkblue_v3') ||
        (variantNumber === 3 && 'purple_v3') ||
        ''
    }
  }

  const imageUrl1x = `https://lfs.creativefabrica.com/web/features/promos/${name}-1x.jpg`
  const imageUrl2x = `https://lfs.creativefabrica.com/web/features/promos/${name}-2x.jpg`

  return {
    src: `${imageUrl1x}`,
    srcSet: `${imageUrl1x} 1x, ${imageUrl2x} 2x`,
    alt: `Promo Popup ${
      // oxlint-disable-next-line no-nested-ternary, unicorn/no-nested-ternary
      variantNumber === 1 ? 'Blue' : variantNumber === 2 ? 'Dark Blue' : 'Purple'
    } Background Image`,
  }
}
